module.exports = __webpack_public_path__ + "img/content_make16.5cbbf767.png";